import { ClosableModal } from '@Components/shared/dialogs/ClosableModal';
import { useTransactionExportsTable } from '@Modal/hooks/transactionExports/useTransactionExportsTable';
import { TransactionExportFormProvider } from '../../providers/forms/transactions/TransactionExportFormProvider';
import { TransactionExportContent } from './TransactionExportContent';

export const TransactionExportModalDialog = () => {
  const {
    closeTransactionExportModal,
    showTransactionExportModal,
    defaultStartDate,
    defaultEndDate,
  } = useTransactionExportsTable();

  return (
    <>
      {showTransactionExportModal && (
        <ClosableModal
          name="ExportTransactions"
          title="Export Transactions"
          open={showTransactionExportModal}
          onClose={closeTransactionExportModal}
          sx={{ width: '592px' }}
        >
          <TransactionExportFormProvider>
            <TransactionExportContent
              defaultStartDate={defaultStartDate}
              defaultEndDate={defaultEndDate}
            />
          </TransactionExportFormProvider>
        </ClosableModal>
      )}
    </>
  );
};
